import { NgModule } from '@angular/core';

import { DotCmsContainerEditWrapperDirective } from './dot-cms-container-edit-wrapper.directive';
import { DotCmsContentletEditWrapperDirective } from './dot-cms-contentlet-edit-wrapper.directive';
import { DotCmsPageContextDirective } from './dot-cms-page-context.directive';
import { DotCmsSetAttributesDirective } from './dot-cms-set-attributes.directive';

@NgModule({
  imports: [],
  declarations: [
    DotCmsContainerEditWrapperDirective,
    DotCmsContentletEditWrapperDirective,
    DotCmsPageContextDirective,
    DotCmsSetAttributesDirective,
  ],
  exports: [
    DotCmsContainerEditWrapperDirective,
    DotCmsContentletEditWrapperDirective,
    DotCmsPageContextDirective,
    DotCmsSetAttributesDirective,
  ],
})
export class DotCmsDirectivesModule {}
